// React
import { ReactElement } from 'react';
// Design System
import { Skeleton } from '@utmb/design-system/placeholder/Placeholder';
// Styles
import styles from './registration-skeleton.module.scss';

const RegistrationSkeleton = (): ReactElement => {
    return (
        <div className={styles.root}>
            <Skeleton className={styles.title} width="75%" height="28" />
            <Skeleton className={styles.summary} width="60%" height="16" />
            <Skeleton className={styles.summary} width="25%" height="16" />
            <Skeleton className={styles.gender_label} width="5%" height="14" />
            <ul className={styles.gender_radio}>
                <li key="skel-gender1" className={styles.gender_radio_item}>
                    <Skeleton width="80%" height="28" />
                </li>
                <li key="skel-gender2" className={styles.gender_radio_item}>
                    <Skeleton width="100%" height="28" />
                </li>
            </ul>

            <ul className={styles.input_list}>
                {[...new Array(6)].map((val, index) => (
                    <li key={`regskel${index}`} className={styles.input_item}>
                        <Skeleton className={styles.input_item_label} width="20%" height="14" />
                        <Skeleton className={styles.input_item_value} width="60%" height="28" />
                    </li>
                ))}
            </ul>

            <Skeleton className={styles.conssent} width="80%" height="28" />
            <Skeleton className={styles.conssent} width="70%" height="28" />
            <Skeleton className={styles.submit} width="25%" height="60" />
        </div>
    );
};

export default RegistrationSkeleton;
